import React from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormTextField, Stack, useNotifications } from "sprint-common-web";

import { useOrdersModuleApi } from "../../common/useOrdersModuleApi";

interface RejectOrderFormInputs {
    rejectionReason: string;
}

export interface RejectOrderFormProps {
    orderId: string;
    onCancel(): void;
    onSubmit(): void;
}

export const RejectOrderForm: React.VFC<RejectOrderFormProps> = ({
    orderId,
    onCancel,
    onSubmit
}: RejectOrderFormProps) => {
    const { control, errors, formState, handleSubmit } = useForm<RejectOrderFormInputs>({
        defaultValues: {
            rejectionReason: ""
        },
        criteriaMode: "all"
    });

    const { success } = useNotifications();
    const { rejectOrder } = useOrdersModuleApi();

    const handleRejectOrder = async ({ rejectionReason }: RejectOrderFormInputs) => {
        await rejectOrder({ orderId, rejectionReason });

        onSubmit();
        success("Order rejected");
    };

    return (
        <Stack>
            <Form onSubmit={handleSubmit(handleRejectOrder)}>
                <Stack verticalAlign="space-between">
                    <FormFields>
                        <FormTextField
                            label="Rejection reason"
                            control={control}
                            name="rejectionReason"
                            errors={errors}
                            rules={{ required: "Enter rejection reason" }}
                            multiline={true}
                        />
                        <FormActions onCancel={onCancel} isLoading={formState.isSubmitting || formState.isValidating} />
                    </FormFields>
                </Stack>
            </Form>
        </Stack>
    );
};
